import { trackEvent } from '@99designs/common/utils/platform';
import Heading from 'common/components/Heading';
import { scrollToElementWithSpeed } from 'common/utils/scroll';
import React from 'react';

interface Props {
    category: string;
    onProceed(): void;
    hasAnimation: boolean;
}

const IntentSelect = ({ onProceed, category, hasAnimation }: Props) => {
    const howItWorks = document.querySelector('#how_it_works');
    const featuredContestsCarousel = document.querySelector('#featured_contests_carousel');
    const stickyNavHeight = 90; // To be removed if we decide to remove sticky nav
    let className =
        'get-started-interactive-content get-started-interactive-content--intent-select';

    if (hasAnimation) {
        className = className + ' get-started-interactive-content--with-animation';
    }

    return (
        <div className={className}>
            <div className="get-started-interactive-content__inner">
                <div className="get-started-interactive-content__inner__item">
                    <button className="input-card input-card--intent" onClick={onProceed}>
                        <span className="input-card__card">
                            <span className="marketing-icon marketing-icon--logo-design" />
                            <Heading size="h5" variations={['heading--quarter-margin']}>
                                I need a logo
                            </Heading>
                            <span className="paragraph paragraph--small paragraph--soft paragraph--no-margin">
                                We’ll help you get the perfect design.
                            </span>
                        </span>
                    </button>
                </div>

                <div className="get-started-interactive-content__inner__item">
                    <a
                        onClick={event => {
                            if (howItWorks) {
                                event.preventDefault();
                                scrollToElementWithSpeed(howItWorks, stickyNavHeight, 1600);
                                trackEvent('Clicked Prelaunch Interactive Intention', {
                                    name: 'how it works',
                                    category: category,
                                });
                            }
                        }}
                        href="#how_it_works"
                        className="input-card input-card--intent"
                    >
                        <span className="input-card__card">
                            <span className="marketing-icon marketing-icon--other" />
                            <Heading size="h5" variations={['heading--quarter-margin']}>
                                Tell me about the process
                            </Heading>
                            <span className="paragraph paragraph--small paragraph--soft paragraph--no-margin">
                                We make custom logo design simple and fun.
                            </span>
                        </span>
                    </a>
                </div>

                <div className="get-started-interactive-content__inner__item">
                    <a
                        onClick={event => {
                            if (featuredContestsCarousel) {
                                event.preventDefault();
                                scrollToElementWithSpeed(featuredContestsCarousel, 0, 1600);
                                trackEvent('Clicked Prelaunch Interactive Intention', {
                                    name: 'inspiration',
                                    category: category,
                                });
                            }
                        }}
                        href="#featured_contests_carousel"
                        className="input-card input-card--intent"
                    >
                        <span className="input-card__card">
                            <span className="icon icon--designs-1" />
                            <Heading size="h5" variations={['heading--quarter-margin']}>
                                Show me great logos
                            </Heading>
                            <span className="paragraph paragraph--small paragraph--soft paragraph--no-margin">
                                Our designers average a 4.8 star rating.
                            </span>
                        </span>
                    </a>
                </div>
            </div>
        </div>
    );
};

export default IntentSelect;
